import { PRIVATE_MODULES_PATH } from "./root.path";

export const PATH_ROUTER_USER = {
  LIST: "/",
  CREATE: "create",
  EDIT: "edit",
  DETAIL: "detail"
};

const BASE = PRIVATE_MODULES_PATH.USERS;
const { CREATE, DETAIL, EDIT, LIST } = PATH_ROUTER_USER;

export const PATH_ROUTES_USER = {
  LIST: `/${BASE}/${LIST}`,
  CREATE: `/${BASE}/${CREATE}`,
  EDIT: (id: number) => `/${BASE}/${EDIT}/${id}`,
  DETAIL: (id: number) => `/${BASE}/${DETAIL}/${id}`
};
